import { Stack } from '@mui/material';
import { UserInfoForm } from './components';
import { ContentBox } from '@/components/shared/content-box';
import { PageContainer } from '@/components/shared/page-container';
import { useSetTitle } from '@/hooks/use-set-title';
import { InterestsSection } from '@/packages/my-profile/components/interests-section';
import { PreferencesSection } from '@/packages/my-profile/components/preferences-section';

export const MyProfile = () => {
  useSetTitle('Meu perfil');

  return (
    <PageContainer>
      <ContentBox mb={3}>
        <UserInfoForm />
      </ContentBox>
      <ContentBox>
        <Stack spacing={3}>
          <InterestsSection />
          <PreferencesSection />
        </Stack>
      </ContentBox>
    </PageContainer>
  );
};
